export const clearParams = () =>
  window.history.replaceState({}, document.title, window.location.pathname);
